import * as React from 'react'
import * as UI from '@brewlogix/blx-ui'

import AttractionCard from './AttractionCard'
import { NearbyAttraction } from 'src/types/schema/graphql'
import classNames from 'classnames'
import { useStickyNav } from '../../state/useStickyNav'

interface INearbyAttractions {
    attractions: NearbyAttraction[]
    attractionsRef: React.Ref<HTMLDivElement>
}

const NearbyAttractions: React.FC<INearbyAttractions> = ({ attractions = [], attractionsRef }) => {
    const { space } = useStickyNav()
    return (
        <div className={classNames('space-y-6', space)} id='attractions' ref={attractionsRef}>
            <UI.Heading
                text='Nearby Attractions'
                size='h4'
                type='h2'
                customClasses='text-xl lg:text-2xl'
            />
            <div className='grid grid-cols-2 gap-4 md:flex md:flex-row'>
                {attractions.length ? (
                    attractions.map((a) => <AttractionCard attraction={a} key={a.title} />)
                ) : (
                    <p>Attractions coming soon... </p>
                )}
            </div>
        </div>
    )
}

export default NearbyAttractions
